import React, { Component } from 'react';
import { connect } from 'react-redux';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import { t } from '../../../../locales';
import { getaxaGoalTrackerModal } from '../../selectors/vhisSelectors';
import {
  resolvePublicAssets,
  resolveLocalizedText,
  isApp,
} from '../../../../utils/';
import './styles.scss';
declare let dataLayer: any;

interface TrackerConnectModalViewProps {
  trackerconnectInfo: any;
  trackerDisconnectInfo: any;
  isTrackerDisconnected: boolean;
  connectedDevices: Array<any>;
  membershipPeriod: string;
  closeVhisModal: () => void;
}

class TrackerConnectModalView extends Component<TrackerConnectModalViewProps> {
  constructor(props: any) {
    super(props);
    this.goToAppView = this.goToAppView.bind(this);
  }

  goToAppView(url: string) {
    dataLayer.push({
      event: 'healthKeeper',
    });
    if (isApp()) {
      EmmaFactory.createInstance().then((e) => {
        e.instance.goTo(url);
      });
    }
  }

  render() {
    const {
      isTrackerDisconnected,
      closeVhisModal,
      trackerconnectInfo,
      trackerDisconnectInfo,
      connectedDevices,
      membershipPeriod,
    } = this.props;

    return (
      <div>
        <div className="tracker-modal">
          <div
            className={`tracker-modal__content ${
              isTrackerDisconnected ? 'tracker-modal__content-disconnect' : ''
            }`}
          >
            <img
              className="tracker-modal__close"
              onClick={closeVhisModal}
              src={
                isTrackerDisconnected
                  ? trackerDisconnectInfo.closeBtn
                  : trackerconnectInfo.closeBtn
              }
              alt=""
              data-enable-ga
              data-ga-type="button"
            />

            <div className="tracker-modal__content-top-container">
              <img
                className="tracker-modal__content-img"
                src={
                  isTrackerDisconnected
                    ? trackerDisconnectInfo.connectImg
                    : trackerconnectInfo.connectImg
                }
                alt=""
              />
              <div className="tracker-modal__content-txt">
                <div className="tracker-modal__content-title">
                  {isTrackerDisconnected
                    ? trackerDisconnectInfo.title
                    : trackerconnectInfo.title}
                </div>
                {isTrackerDisconnected ? (
                  <div className="tracker-modal__content-desc">
                    {trackerDisconnectInfo.desc}
                  </div>
                ) : (
                  <div className="tracker-modal__content-list">
                    {connectedDevices.length > 0 &&
                      connectedDevices.map((item) => {
                        return (
                          <div className="tracker-modal__content-li">
                            <span className="tracker-modal__content-li-point">
                              •
                            </span>
                            {item}
                          </div>
                        );
                      })}
                  </div>
                )}
                {!isTrackerDisconnected && (
                  <div className="tracker-modal__content-title">
                    {t('MEMBERSHIP_PERIOD')}
                  </div>
                )}
                {!isTrackerDisconnected && (
                  <div className="tracker-modal__content-membership-period">
                    {membershipPeriod}
                  </div>
                )}
              </div>
            </div>

            {isTrackerDisconnected && (
              <div className="tracker-modal__content-connect">
                <button
                  id="tracker-connect-btn"
                  className="tracker-modal__content-connect-btn"
                  onClick={() => {
                    this.goToAppView('health-keeper/tracker');
                  }}
                  data-enable-ga
                  data-ga-type="button"
                >
                  {t('CONNECT')}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any) {
    const trackerModalInfo = getaxaGoalTrackerModal(state);
    const connectInfo =
      trackerModalInfo && trackerModalInfo.connectInfo
        ? trackerModalInfo.connectInfo
        : {};
    const disconnectInfo =
      trackerModalInfo && trackerModalInfo.disconnectInfo
        ? trackerModalInfo.disconnectInfo
        : {};
    return {
      trackerconnectInfo: {
        closeBtn: connectInfo.closeButton
          ? resolvePublicAssets(connectInfo.closeButton)
              .replace('.png', '@3x.png')
              .replace('.jpg', '@3x.jpg')
          : '',
        connectImg: connectInfo.connectImg
          ? resolvePublicAssets(connectInfo.connectImg)
              .replace('.png', '@3x.png')
              .replace('.jpg', '@3x.jpg')
          : '',
        title: connectInfo.title ? resolveLocalizedText(connectInfo.title) : '',
      },
      trackerDisconnectInfo: {
        closeBtn: disconnectInfo.closeButton
          ? resolvePublicAssets(disconnectInfo.closeButton)
              .replace('.png', '@3x.png')
              .replace('.jpg', '@3x.jpg')
          : '',
        connectImg: disconnectInfo.connectImg
          ? resolvePublicAssets(disconnectInfo.connectImg)
              .replace('.png', '@3x.png')
              .replace('.jpg', '@3x.jpg')
          : '',
        title: disconnectInfo.title
          ? resolveLocalizedText(disconnectInfo.title)
          : '',
        desc: disconnectInfo.desc
          ? resolveLocalizedText(disconnectInfo.desc)
          : '',
      },
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  TrackerConnectModalView.mapStateToProps,
  TrackerConnectModalView.mapDispatchToProps,
)(TrackerConnectModalView);
